import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Chip, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Collapse from "@mui/material/Collapse";
import {Box, Grid} from "@mui/material";
import ImageGallery from "react-image-gallery";
import Typography from "@mui/material/Typography";
import {createData} from "./DetailedDataWidget";

const DetailedDataRow = (props: { row: ReturnType<typeof createData> }) => {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const [gallery, setGallery] = useState<{original: string, thumbnail: string, description: string}[]>([])
    const { t } = useTranslation()

    useEffect(() => {
        if (row.images.length > 0) {
            const preparedGallery = row.images.map((i: any) => ({
                original: i.image,
                thumbnail: i.thumbnails.small,
                description: i.answer ? i.answer.title : ''
            }))
            setGallery(preparedGallery)
        }
    }, [row]);

    return (
        <React.Fragment>
            <TableRow>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ?
                            <KeyboardArrowUpIcon style={{color: '#FFF'}} /> :
                            <KeyboardArrowDownIcon style={{color: '#FFF'}} />
                        }
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {row.name}
                </TableCell>
                <TableCell align="center">{row.costLevel}</TableCell>
                <TableCell align="center">
                    <Chip
                        label={row.mandatory ? 'Mandatory' : 'Recommended'}
                        variant={'outlined'}
                    />
                </TableCell>
                <TableCell align="center">{row.amount}</TableCell>
                <TableCell align="right">{row.cost}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box m={2}>
                            <Grid container spacing={3}>
                                <Grid item xs={3}>
                                    <Box>
                                        <Typography>Example of best practice</Typography>
                                    </Box>
                                    {gallery.length > 0 ? (
                                        <ImageGallery
                                            items={gallery}
                                            showThumbnails={gallery.length > 1}
                                            showPlayButton={false}
                                        />
                                    ) : (
                                        <Box
                                            display={'flex'}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            height={'100%'}
                                            style={{background: '#233145'}}
                                        >
                                            {t('no_picture')}
                                        </Box>
                                    )}
                                </Grid>
                                <Grid item xs={9}>
                                    <Table size="small" aria-label="purchases">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography variant={'h6'}>Unit name</Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {row.detailed.map((i, index: number) => (
                                                <TableRow key={index}>
                                                    <TableCell>{`${i.unit_title} - ${i.unit_name}`}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Grid>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default DetailedDataRow
